export default {
  // 指令绑定到元素时执行
  bind(el, binding) {
    let isDragging = false;
    let startX, startY;
    let initialLeft, initialTop;

    el.addEventListener('mousedown', onMouseDown);
    el.addEventListener('mousemove', onMouseMove);
    el.addEventListener('mouseup', onMouseUp);
    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    el.addEventListener('touchend', onTouchEnd, { passive: true });

    function onMouseDown(event) {
      isDragging = true;
      startX = event.clientX;
      startY = event.clientY;
      initialLeft = el.offsetLeft;
      initialTop = el.offsetTop;

      // 禁止文本选择功能
      event.preventDefault();
      window.getSelection().removeAllRanges();

      // 禁用鼠标右键默认行为
      if (event.button === 2) {
        event.preventDefault();
      }
    }

    function onMouseMove(event) {
      if (!isDragging) return;

      let deltaX = event.clientX - startX;
      let deltaY = event.clientY - startY;

      let newLeft = initialLeft + deltaX;
      let newTop = initialTop + deltaY;

      el.style.left = `${newLeft}px`;
      el.style.top = `${newTop}px`;
    }

    function onMouseUp(event) {
      isDragging = false;
    }

    function onTouchStart(event) {
      isDragging = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      initialLeft = el.offsetLeft;
      initialTop = el.offsetTop;

      // 禁用页面滚动
      if (window && window.document) {
        window.document.body.style.overflow = 'hidden';
      }
    }

    function onTouchMove(event) {
      if (!isDragging) return;

      let deltaX = event.touches[0].clientX - startX;
      let deltaY = event.touches[0].clientY - startY;

      let newLeft = initialLeft + deltaX;
      let newTop = initialTop + deltaY;

      el.style.left = `${newLeft}px`;
      el.style.top = `${newTop}px`;
    }

    function onTouchEnd(event) {
      isDragging = false;

      // 恢复页面滚动
      if (window && window.document) {
        window.document.body.style.overflow = '';
      }
    }
  }
};
